module.exports = __webpack_public_path__ + "img/opencart.c7f8c363.svg";